<template>
  <b-alert :variant="status.variant" show>
    {{ status.message }}
    <b-button
      v-if="status.recheck"
      variant="light"
      size="sm"
      @click="$emit('recheck')"
    >
      <i class="icon-reload-alt" />
      {{ $t('orders.recheck_payment_status') }}
    </b-button>
  </b-alert>
</template>

<script>
export default {
  name: 'PaymentStatus',

  emits: ['recheck'],

  props: {
    status: {
      type: Object,
      required: true,
    },
  },
}
</script>
